export default {
  data() {
    return {
      prevRoute: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  computed: {
    backUrl() {
        return this.$router.resolve({ name: 'registration' }).href;
    }
  },
};



// WEBPACK FOOTER //
// ./src/mixins/back-url.js